/**
 * application.ts - General application preferences module
 * 
 * CHANGE HISTORY:
 * - 251023_1854 [pending] danielbeer: Initial creation
 */

export const applicationModule = {
  id: 'app-general',
  name: 'Application',
  icon: '⚙️',
  category: 'general',
  order: 1,
  settings: {
    appName: {
      type: 'string',
      label: 'Application Name',
      description: 'Display name for this application',
      defaultValue: 'OpCentral App'
    },
    
    language: {
      type: 'select',
      label: 'Language',
      description: 'Interface language',
      defaultValue: 'en',
      options: [
        { label: 'English', value: 'en' },
        { label: 'Spanish', value: 'es' },
        { label: 'French', value: 'fr' },
        { label: 'German', value: 'de' },
        { label: 'Japanese', value: 'ja' },
        { label: 'Chinese', value: 'zh' }
      ]
    },
    
    autoSave: {
      type: 'boolean',
      label: 'Auto-save',
      description: 'Automatically save changes',
      defaultValue: true
    },
    
    autoSaveInterval: {
      type: 'number',
      label: 'Auto-save Interval (seconds)',
      description: 'How often to auto-save',
      defaultValue: 60,
      min: 10,
      max: 600,
      visible: (settings) => settings['app-general.autoSave']
    },
    
    confirmBeforeExit: {
      type: 'boolean',
      label: 'Confirm Before Exit',
      description: 'Ask for confirmation when closing the app',
      defaultValue: true
    },
    
    showWelcomeScreen: {
      type: 'boolean',
      label: 'Show Welcome Screen',
      description: 'Display welcome screen on startup',
      defaultValue: true
    },
    
    checkForUpdates: {
      type: 'boolean',
      label: 'Check for Updates',
      description: 'Automatically check for application updates',
      defaultValue: true
    }
  }
};

export default applicationModule;
